import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import PainPoints from '../components/PainPoints';
import StrategicBlock from '../components/StrategicBlock';
import Services from '../components/Services';
import Methodology from '../components/Methodology';
import UseCases from '../components/UseCases';
import DiagnosticQuiz from '../components/DiagnosticQuiz';
import QualifyingForm from '../components/QualifyingForm';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';

const HomePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E9DFCF' }} data-testid="home-page">
      {/* Skip link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 bg-blue-700 text-white px-4 py-2 z-50"
      >
        Aller au contenu principal
      </a>

      <Header />

      <main id="main-content">
        <Hero />
        <PainPoints />
        <StrategicBlock />
        <Services />
        <Methodology />
        <UseCases />
        <DiagnosticQuiz />
        <QualifyingForm />
        <Pricing />
        <Testimonials />
      </main>

      <Footer />
      <CookieConsent />
    </div>
  );
};

export default HomePage;
